const STEP_ERROR_MESSAGES = {
  INSPECTION_STEPS_INCOMPLETE: "Every step must be passed before you can pass the employee.",
  INSPECTION_STEP_COMMENT_REQUIRED: "A comment is required to fail a step.",
  INSPECTION_STEPS_LOCKED: "The inspection is final, so its steps can no longer be changed.",
};

/** Message for a per-step inspection API error (422 `{ code, details }`), or null when unrecognised. */
export function inspectionStepErrorMessage(error) {
  const code = error?.response?.data?.code;
  return STEP_ERROR_MESSAGES[code] ?? null;
}
